import React, { useState, useEffect } from 'react';
import { useT } from 'talkr';
import s from './index.module.scss';
import common from '../../index.module.scss';
import validateEmail from '../../../utils/scripts/validateEmail';
import { useAppStore, useQuestionsStore } from '../../../store';

function StepTitle({ userGoal }) {
  const { T } = useT();

  const goal = userGoal ? T(`goal_${userGoal}`) : T('goal_teaching_puppy');

  return (
    <>
      {T('email_title_part_1')}
      &nbsp;
      <span className={s.goal}>{goal}</span>
      &nbsp;
      {T('email_title_part_2')}
    </>
  );
}

function Mail(props) {
  const { T } = useT();
  const { isThisCurrentStep } = props;
  const { isCurrentStepCompleted } = props;
  const isThisCurrentStepClass = isThisCurrentStep ? s.stepSelected : '';
  const isThisStepCompletedClass = isCurrentStepCompleted ? s.stepCompleted : '';
  const currentStep = useAppStore((state) => state.currentStep);
  const placeholder = T('email_placeholder');
  const emailWarningShort = T('email_warning_short');
  const emailWarningLong = T('email_warning_long');
  const emailWarning = T('email_warning');
  const [userGoal, setUserGoal] = useState(false);

  const savedQuestionValues = useQuestionsStore((state) => state.savedAnswers.mail);
  const list = useAppStore((state) => state.list);

  const savedValue = savedQuestionValues && savedQuestionValues.value;
  const agreeToInboxSavedValue = savedQuestionValues && savedQuestionValues.agreeToInbox;

  const [value, setValue] = useState(savedValue || '');
  const [validationWarning, setValidation] = useState(false);
  const [agreeToInbox, setAgreeToInbox] = useState(agreeToInboxSavedValue || false);

  function validate() {
    if (value && (value.length >= 63)) {
      setValidation(emailWarningLong);
      return;
    }

    if (value && (value.length <= 5)) {
      setValidation(emailWarningShort);
      return;
    }

    if (!validateEmail(value) && value !== '') {
      setValidation(emailWarning);
      return;
    }

    setValidation(validateEmail(value));
  }

  useEffect(() => {
    validate();
  }, [value, currentStep]);

  function onChangeAction(e) {
    setValue(e.target.value);

    useQuestionsStore.getState().setAnswer({
      questionName: 'mail',
      answerName: 'value',
      answerValue: e.target.value,
    });
  }

  useEffect(() => {
    const completed = (value !== '' && validationWarning === true);
    useAppStore.getState().setCurrentStepCompleted(completed);
  }, [value, list, currentStep, validationWarning]);

  useEffect(() => {
    const goal = useQuestionsStore.getState().getAnswers({ questionName: 'goal' })[Object.keys(useQuestionsStore.getState().getAnswers({ questionName: 'goal' }))[0]];

    setUserGoal((goal && goal.value) || false);
  }, [currentStep]);

  function changeCheckbox(e) {
    setAgreeToInbox(e.target.checked);

    useQuestionsStore.getState().setAnswer({
      questionName: 'mail',
      answerName: 'agreeToInbox',
      answerValue: e.target.checked,
    });
  }

  function actionOnFocus() {
    setTimeout(() => {
      document.documentElement.scrollTop = -300;
    }, 50);
  }

  return (
    <div className={`${common.step} ${s.step} ${isThisCurrentStepClass} ${isThisStepCompletedClass}`}>
      <div className={common.stepTitle}>
        <StepTitle userGoal={userGoal} />
      </div>
      <input
        className={s.value}
        id="mail"
        type="email"
        value={value}
        pattern=".+@globex\.com"
        autoComplete="true"
        placeholder={placeholder}
        onChange={onChangeAction}
        onFocus={actionOnFocus}
        tabIndex={!isThisCurrentStep ? -1 : ''}
      />
      {
        validationWarning
        && (
          <div className={s.warning}>
            {validationWarning}
          </div>
        )
      }
      <div className={s.description}>
        <div>
          <svg className={s.lock} alt="Lock icon" width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.00004 8.14836C0.894648 8.152 0 9.14095 0 10.3773V17.7711C0 19.0023 0.897353 20 2.00599 20H11.994C13.1021 20 14 19.0096 14 17.7711V10.3773C14 9.1484 13.1059 8.15132 12 8.14836V5.55497C12 2.48672 9.75587 0 6.99985 0C4.23849 0 1.99974 2.48672 1.99974 5.55497L2.00004 8.14836ZM4.00009 8.14836V5.55632C4.00009 3.71035 5.34343 2.22216 7.00015 2.22216C8.65344 2.22216 10.0002 3.7148 10.0002 5.55632V8.14836H4.00009Z" />
          </svg>
        </div>
        {T('email_description_2')}
      </div>

      <div className={s.checkboxWrapper}>
        <input data-prevent-from-blur className={s.inputToHide} type="checkbox" onChange={changeCheckbox} id="agree" checked={agreeToInbox} tabIndex={!isThisCurrentStep ? -1 : ''} />
        <label className={s.checkbox} htmlFor="agree">{T('email_description')}</label>
      </div>
    </div>
  );
}

export default Mail;
